import axios from 'axios';

export const postToCheckCode = async (requestData) => {
  return await axios.post('/api/accounts/check_code/', requestData);
};
